import React, { useMemo, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Alert, Button, Divider, Typography } from "antd";
import { request } from "../../functions/request";
import Aguarde from "../../components/aguarde/aguarde";
import { AiOutlineSearch, AiFillEdit, AiFillDelete } from "react-icons/ai";
import { VscCircleLargeFilled } from "react-icons/vsc";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { Content } from "antd/es/layout/layout";
import { FaPlus } from "react-icons/fa";
import ModalAddModelo from "../../components/Modal/Modelo/ModalAddModelo";

const TIPO_LABEL = {
  noticia: "Notícias",
  analise: "Análises",
  ambos: "Notícias e Análises",
};

const Modelos = () => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState({});
  const [haveResult, setHaveResult] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [erro, setErro] = useState(false);
  const [abrindo, setAbrindo] = useState(null);

  // Lista sem o conteúdo dos modelos: com ele (getAllModelos) a resposta
  // passava de 7 MB e a tela ficava em "Aguarde" quando não chegava. O
  // conteúdo é buscado só ao clicar em Editar.
  const fetchTableData = async () => {
    setErro(false);
    try {
      const response = await request("/modelo/getListaModelos", {
        method: "GET",
      });
      setTableData(response || []);
      setHaveResult(true);
    } catch (error) {
      console.error("Erro na requisição:", error);
      setErro(true);
    }
  };

  // Só abre o editor com o conteúdo já carregado: aberto vazio, um Salvar
  // apagaria o modelo.
  const abrirEdicao = async (modelo) => {
    setAbrindo(modelo.mod_codigo);
    try {
      const completo = await request(`/modelo/getModelo/${modelo.mod_codigo}`, { method: "GET" });
      if (!completo || typeof completo.mod_conteudo !== "string") throw new Error("modelo sem conteúdo");
      setEditOpen(completo);
      setIsAddOpen(true);
    } catch (error) {
      console.log(error);
      toast.error("Não foi possível abrir o modelo. Tente de novo.");
    } finally {
      setAbrindo(null);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const deleteModelo = async (mod_codigo) => {
    try {
      await request(`/modelo/deleteModelo/${mod_codigo}`, {
        method: "DELETE",
      });
      toast.success("Modelo excluído com sucesso!");
      fetchTableData();
    } catch (error) {
      console.log(error);
      toast.error("Erro ao excluir modelo!");
    }
  };

  const confirmDelete = (row) => {
    confirmAlert({
      title: "Você tem certeza que deseja excluir esse modelo?",
      message: "Essa ação será irreversível.",
      buttons: [
        { label: "Não", className: "button-delete", onClick: () => {} },
        {
          label: "Sim",
          className: "button-save",
          onClick: () => deleteModelo(row.original.mod_codigo),
        },
      ],
    });
  };

  const columns = useMemo(
    () => [
      { accessorKey: "mod_codigo", header: "Id", size: 10 },
      { accessorKey: "mod_nome", header: "Nome do Modelo", size: 200 },
      {
        accessorKey: "mod_tipo",
        header: "Tipo",
        size: 80,
        Cell: ({ cell }) => TIPO_LABEL[cell.getValue()] || cell.getValue(),
      },
      {
        accessorKey: "mod_ativo",
        header: "Ativo",
        size: 50,
        Cell: ({ cell }) =>
          cell.getValue() ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled color="info" fontSize="small" className="active-icon" />
              Ativo
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled
                color="info"
                fontSize="small"
                style={{ color: "var( --gray-color)" }}
              />
              Inativo
            </div>
          ),
      },
    ],
    []
  );

  return (
    <>
      <ModalAddModelo
        isOpen={isAddOpen}
        editData={editOpen}
        onClose={() => setIsAddOpen(false)}
        onSaved={fetchTableData}
      />
      {haveResult ? (
        tableData.length > 0 ? (
          <MaterialReactTable
            columns={columns}
            data={tableData}
            defaultColumn={{ minSize: 5, maxSize: 200, size: 100 }}
            enableColumnFilterModes
            enableColumnSorting
            enableRowActions
            localization={MRT_Localization_PT_BR}
            positionActionsColumn="last"
            enableRowVirtualization
            enableFacetedValues
            columnFilterModeOptions={null}
            initialState={{
              showColumnFilters: true,
              pagination: { pageIndex: 0, pageSize: 20 },
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "", size: 100 },
            }}
            renderRowActions={({ row }) => (
              <div style={{ display: "flex", gap: "5px", justifyContent: "end" }}>
                <Button
                  loading={abrindo === row.original.mod_codigo}
                  onClick={() => abrirEdicao(row.original)}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <AiFillEdit />
                  Editar
                </Button>
                <Button
                  danger
                  onClick={() => confirmDelete(row)}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <AiFillDelete />
                  Excluir
                </Button>
              </div>
            )}
            renderTopToolbarCustomActions={() => (
              <Content style={{ display: "flex", alignItems: "center", gap: 20, padding: 10 }}>
                <Typography.Title
                  level={4}
                  style={{ margin: 0, display: "flex", gap: 5, alignItems: "center" }}
                >
                  Modelos de Matéria
                </Typography.Title>
                <Divider type="vertical" />
                <Button
                  type="primary"
                  icon={<FaPlus />}
                  size="large"
                  onClick={() => {
                    setEditOpen({});
                    setIsAddOpen(true);
                  }}
                >
                  Adicionar Modelo
                </Button>
              </Content>
            )}
            muiTableHeadCellFilterTextFieldProps={{ placeholder: "Filtrar" }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "80%",
            }}
          >
            <Content style={{ display: "flex", justifyContent: "flex-end", padding: 10 }}>
              <Button
                type="primary"
                icon={<FaPlus />}
                size="large"
                onClick={() => {
                  setEditOpen({});
                  setIsAddOpen(true);
                }}
              >
                Adicionar Modelo
              </Button>
            </Content>
            <h2>Nenhum modelo cadastrado ainda.</h2>
            <AiOutlineSearch size={48} color="#888" />
          </div>
        )
      ) : erro ? (
        <Alert
          type="error"
          showIcon
          style={{ margin: 16 }}
          message="Não foi possível carregar os modelos."
          action={<Button onClick={fetchTableData}>Tentar novamente</Button>}
        />
      ) : (
        <Aguarde />
      )}
    </>
  );
};

export default Modelos;
